import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { parseData } from '@ups/xplat/utils';
import {
  ContainerDTO,
  ContainerItemTreeGridDTO,
  ContainerTypeDTO,
} from '../models';
import { IODataResult } from '@ups/xplat/api/dto';

const CONTAINER = '/api/container';
const CONTAINER_ODATA = '/api/container/odata';
const CONTAINER_BY_CONTAINER_TYPE_ID = (id) =>
  `/api/container/byContainerTypeId/${id}`;
const CONTAINER_BY_ID = (id) => `/api/container/${id}`;
const CONTAINER_ITEM_TREE_GRID_BY_ID = (id) => `/api/container/treegrid/${id}`;
const CONTAINER_ITEM_TREE_GRID_BY_ID_AND_NAME = (
  id,
  containerNumber,
  containerName
) => `/api/container/treegrid/${id}/${containerNumber}/${containerName}`;
const CONTAINER_TYPES = '/api/container/containerTypes';
//const CONTRACT_DETAIL = (id) => `/api/Contracts/${id}`;

@Injectable({
  providedIn: 'root',
})
export class ContainerService {
  private http: HttpClient;

  constructor(httpClientFactory: MyHttpClientFactory) {
    this.http = httpClientFactory.createHttpClient(
      environment.urls.toolTrackerAPI,
      true
    );
  }

  public getContainerOData(
    odataQueryString = null,
    includeCount = false
  ): Observable<IODataResult<ContainerDTO>> {
    const url = CONTAINER_ODATA;
    let queryParams = new HttpParams();
    if (odataQueryString) {
      odataQueryString.split('&').forEach((item) => {
        const [key, value] = item.split('=');
        queryParams = queryParams.append(key, value);
      });
    }
    if (includeCount) {
      queryParams = queryParams.append('$count', 'true');
    }
    if (!queryParams.keys().some((x) => x === '$top')) {
      queryParams = queryParams.append('$top', '20');
    }
    return this.http
      .get<IODataResult<ContainerDTO>>(url, { params: queryParams })
      .pipe(map(parseData));
  }

  public getContainersByType(
    containerTypeId: string
  ): Observable<ContainerDTO[]> {
    const url = CONTAINER_BY_CONTAINER_TYPE_ID(containerTypeId);
    return this.http.get<ContainerDTO[]>(url).pipe(map(parseData));
  }

  public getContainerItemTreeGridById(
    containerId: string
  ): Observable<ContainerItemTreeGridDTO[]> {
    const url = CONTAINER_ITEM_TREE_GRID_BY_ID(containerId);
    return this.http.get<ContainerItemTreeGridDTO[]>(url).pipe(map(parseData));
  }

  public getContainerItemTreeGridByContainerTypeAndName(
    containerTypeId: string,
    containerNumber: string,
    containerName: string
  ): Observable<ContainerItemTreeGridDTO[]> {
    const url = CONTAINER_ITEM_TREE_GRID_BY_ID_AND_NAME(
      containerTypeId,
      containerNumber,
      containerName
    );
    return this.http.get<ContainerItemTreeGridDTO[]>(url).pipe(map(parseData));
  }

  public getContainerTypes(): Observable<ContainerTypeDTO[]> {
    const url = CONTAINER_TYPES;
    return this.http.get<ContainerTypeDTO[]>(url).pipe(map(parseData));
  }

  public createContainer(container: ContainerDTO) {
    const url = CONTAINER;
    return this.http.post(url, container);
  }

  public updateContainer(container: ContainerDTO) {
    const url = CONTAINER_BY_ID(container.containerId);
    return this.http.put(url, container);
  }
}
